import"./BetterTogether.css.ts.vanilla.css";var t="_1bb88t00",b="_1bb88t02",e="_1bb88t03",o="_1bb88t04",r="_1bb88t01";export{t as bettterTogetherContainer,b as copy,e as copyLeft,o as copyRight,r as imageStyle};
